module.exports = __webpack_public_path__ + "static/media/img5.5ba79cc8.jpeg";